<div class="not-found full-background-text">
  <h1>So sorry,<br />We couldn’t find what you were looking for...</h1>
  <div class="mt-3">
    <button type="button" class="primary-button" routerLink="/dashboard">
      Go back to dashboard
    </button>
  </div>
</div>
